import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../context/ThemeContext';

const Button = ({ 
  children, 
  variant = 'primary', 
  onClick, 
  className = '',
  type = 'button',
  ...props 
}) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  
  const baseClasses = 'px-6 py-3 rounded-lg font-semibold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2';
  
  const variants = {
    primary: 'bg-afsc-gold text-afsc-charcoal border-2 border-afsc-gold hover:bg-gradient-to-r hover:from-afsc-gold hover:to-afsc-gold-deep shadow-lg hover:shadow-xl',
    secondary: `bg-transparent text-afsc-gold border-2 border-afsc-gold hover:bg-afsc-gold ${isDark ? 'hover:text-white' : 'hover:text-afsc-charcoal'}`,
  };

  return (
    <motion.button
      type={type}
      onClick={onClick}
      className={`${baseClasses} ${variants[variant]} ${className}`}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      {...props}
    >
      {children}
    </motion.button>
  );
};

export default Button;

